"use client";

import PricingCtaSection from "@/components/ui/pricing-cta-section";

/* The site-wide closing CTA. Everything visual — the warm band, the headline
   scale, the buttons, the perk row — belongs to PricingCtaSection; a page only
   supplies its own headline (and body, where it has one). sections/shared/cta
   re-exports this, so most pages render it without going through here. */

export default function HomeCta() {
  return (
    <PricingCtaSection
      id="cta-heading"
      heading="Ready to run on clean proxies?"
      body="Start free today, or talk to our team to build a plan around your scale."
    />
  );
}
